import { render, staticRenderFns } from "./MoreModelActions.vue?vue&type=template&id=63344aac"
import script from "./MoreModelActions.vue?vue&type=script&lang=ts"
export * from "./MoreModelActions.vue?vue&type=script&lang=ts"
import style0 from "./MoreModelActions.vue?vue&type=style&index=0&id=63344aac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports